import { Component, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';

@Component({
  standalone: false,
  selector: 'kt-shift-reward-list',
  templateUrl: './shift-reward-list.component.html',
  styleUrls: ['./shift-reward-list.component.scss']
})
export class ShiftRewardListComponent implements OnInit {
  buttonConfig = BUTTON_CONFIG;
  shiftInfo = null;
  rewardInfo = null;
  loading = signal(false);
  constructor(public activeModal: NgbActiveModal, private scheduleStoreService: ScheduleStoreService) { }

  ngOnInit() {
    this.dispatchGetRewardLIst();
  }

  setRewardData(data) {
    this.loading.set(false);
    if (data.success) {
      this.rewardInfo = data.data.data.rewards;
    }
  }

  dispatchGetRewardLIst() {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      callback: this.setRewardData.bind(this),
      module: SCHEDULE_METHOD_CONSTANT.SHIFT_REWARDS,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: {
        shift_id: this.shiftInfo && this.shiftInfo.shift ? this.shiftInfo.shift.shift_id : 0,
        timesheet_id: this.shiftInfo && this.shiftInfo.timesheet ? this.shiftInfo.timesheet.timesheet_id : 0,
        type: this.shiftInfo && this.shiftInfo.timesheet && this.shiftInfo.timesheet.timesheet_id ? TimesheetType.TIMESHEET : TimesheetType.SHIFT,
      },
    });
  }
}
